import React, { useEffect, useRef, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import vectorIcon from "../../../../../assets/disabilityIcons/icon-park-solid_right-c.svg";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import AddIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";

import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import moment from "moment";
import { Collapse, Table } from "antd";
import { MODULE_API } from "../../../../../apis";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import "./style/medicalHistory.css";
import axios from "axios";

export default function MedicalHistory(props) {
  const inputFileRef = useRef(null);
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [moduleName, setModuleName] = useState("Medical History");
  const [fieldsData, setFieldsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [subModulefields, setSubModuleFields] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("Medical History");
  const [moduleData, setModuleData] = useState([]);

  const [toUpdate, setToUpdate] = useState(false);

  const [tableData, setTableData] = useState({
    currentMedicalConditionsData: [],
    medicationsData: [],
    allergiesData: [],
    previousSurgeriesProceduresData: [],
    familyMedicalHistoryData: [],
    currentTreatmentPlansData: [],
    expectedFutureTreatmentsData: [],
    uploadDocumentMedicalHistoryData: [],
  });

  const { Panel } = Collapse;
  const showModal = async (name) => {
    setModalTitle(name);
    setModuleName(name);
    setIsModalVisible(true);
    setSubModuleFields(null);
    await getSubModuleAttributes(name);
  };
  const viewModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("View Item");
    setSubModuleFields(null);
    await getSubModuleAttributes(record.module);
  };
  const updateModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("Update");
    setSubModuleFields(null);
    await getSubModuleAttributes(record.module);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleItemsInfoSelect = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handelCloseModal = () => {
    setIsModalVisible(false);
    setFormData(null);
  };
  const getAttribute = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(moduleName);
      console.log("response", res, moduleName);
      if (res) {
        res.attributes &&
          res.attributes.map((attribute) => {
            setLoading(false);
            setFields((prevValue) => {
              return {
                ...prevValue,
                [attribute["groupName"]]: {
                  ...(prevValue[attribute["groupName"]] || {}),
                  [attribute["id"]]: attribute,
                },
              };
            });
          });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  
  const getSubModuleAttributes = async (submod) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(submod);
      if (res && res.attributes) {
        setSubModuleFields(res);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };

  const deleteRecord = async (record) => {
    try {
      setLoading(true);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res.records || [],
      }));
    } catch (error) {
      console.error("Failed to delete record:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
    } catch (error) {
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };
  const fetchData = async (moduleName) => {
    try {
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      console.log("checkinggg", res);
      const records = res.records || [];
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const fetchAllModulesData = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);
      const medicalHistoryModule = results.find((item) => item.moduleName === "Medical History");
      console.log("medicalHistoryModule", medicalHistoryModule);

      if (medicalHistoryModule) {
        const targetRecord = medicalHistoryModule.records.find((record) => record.subType === "Disability");
        console.log("targetRecord", targetRecord);
        setFieldsData(targetRecord);
      } else {
        console.log("Medical History module not found");
      }
      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  // console.log("tableData: " tableData)

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const handleCreate = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      // console.log("resultob", result);
      // console.log("resultob", res.records, moduleName);
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setFormData(null);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
      setToUpdate(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };

  const moduleNames = [
    "Current Medical Conditions",
    "Medications",
    "Allergies",
    "Previous Surgeries/Procedures",
    "Family Medical History",
    "Current Treatment Plans",
    "Expected Future Treatments",
    "Medical History",
    "Upload Document Medical history",
  ];
  useEffect(() => {
    fetchAllModulesData();
    // getModulesDocs("Upload Document");
    getAttribute(props.activeStep.name);
  }, []);
  useEffect(() => {
    setTabs(Object.keys(fields));
  }, [fields]);
  useEffect(() => {
    let tabs2 = tabs.map((item) => item.toUpperCase());
    let temp = tabs2.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);
  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);
  console.log("fieldsData", fields);
  console.log("tableData", tableData);

  const columnsData = [
    {
      title: "Condition",
      dataIndex: "Condition",
      key: "Condition",
      render: (text) => text || "N/A",
    },
    {
      title: "Treatment",
      dataIndex: "Treatment",
      key: "Treatment",
      render: (text) => text || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  console.log("fields", fields);
  const medicationColData = [
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render: (text) => text || "N/A",
    },
    {
      title: "Dosage",
      dataIndex: "Dosage",
      key: "dosage",
      render: (text) => text || "N/A",
    },
    {
      title: "Frequency",
      dataIndex: "Frequency",
      key: "frequency",
      render: (text) => text || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const allergyColData = [
    {
      title: "Allergy",
      dataIndex: "Allergy",
      key: "allergy",
      render: (text) => text || "N/A",
    },
    {
      title: "Treatment",
      dataIndex: "Treatment",
      key: "treatment",
      render: (text) => text || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const previousSurgeriesColData = [
    {
      title: "Surgery/Procedure",
      dataIndex: "Surgery/Procedure",
      key: "surgeriesprocedure",
      render: (text) => text || "N/A",
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "date",
      render: (dateString) => moment(dateString).format("MM-DD-YYYY") || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const familyMedicationColsData = [
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render: (text) => text || "N/A",
    },
    {
      title: "Major Disease",
      dataIndex: "Major Disease",
      key: "majordisease",
      render: (text) => text || "N/A",
    },
    {
      title: "Mental Illness",
      dataIndex: "Mental illness",
      key: "mentalillness",
      render: (text) => text || "N/A",
    },
    {
      title: "Allergies",
      dataIndex: "Allergies",
      key: "allergies",
      render: (text) => text || "N/A",
    },
    {
      title: "Addiction",
      dataIndex: "Addiction",
      key: "addiction",
      render: (text) => text || "N/A",
    },
    {
      title: "Notes",
      dataIndex: "Notes",
      key: "notes",
      render: (text) => text || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const currentTreamentPlan = [
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render: (text) => text || "N/A",
    },
    {
      title: "Presenting Problem",
      dataIndex: "Presenting Problem ",
      key: "presentingProblem",
      render: (text) => text || "N/A",
    },
    {
      title: "Diagnosis",
      dataIndex: "Diagnosis",
      key: "diagnosis",
      render: (text) => text || "N/A",
    },
    {
      title: "Objective",
      dataIndex: "Objective",
      key: "objective",
      render: (text) => text || "N/A",
    },
    {
      title: "Treatment Interventions",
      dataIndex: "Treatment Interventions",
      key: "treatmentinterventions",
      render: (text) => text || "N/A",
    },
    {
      title: "Estimated Completion",
      dataIndex: "Estimated Completion",
      key: "estimatedcomplition",
      render: (text) => text || "N/A",
    },
    {
      title: "Notes",
      dataIndex: "Notes",
      key: "notes",
      render: (text) => text || "N/A",
    },

    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const estimatedTreamentPlan = [
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render: (text) => text || "N/A",
    },
    {
      title: "Presenting Problem",
      dataIndex: "Presenting Problem ",
      key: "presentingProblem",
      render: (text) => text || "N/A",
    },
    {
      title: "Diagnosis",
      dataIndex: "Diagnosis",
      key: "diagnosis",
      render: (text) => text || "N/A",
    },
    {
      title: "Objective",
      dataIndex: "Objective",
      key: "objective",
      render: (text) => text || "N/A",
    },
    {
      title: "Treatment Interventions",
      dataIndex: "Treatment Interventions",
      key: "treatmentinterventions",
      render: (text) => text || "N/A",
    },
    {
      title: "Estimated Start",
      dataIndex: "Estimated Completion",
      key: "estimatedcomplition",
      render: (text) => text || "N/A",
    },
    {
      title: "Notes",
      dataIndex: "Notes",
      key: "notes",
      render: (text) => text || "N/A",
    },

    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const handleImageUpload = async (event) => {
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      let objToSubmit = {
        "Document Upload": res,
        "Uploaded File Name": name,
      };
      handleSubmit(objToSubmit);
    }
    inputFileRef.current.value = null;
  };
  const handleSubmit = async (body) => {
    console.log("Submit...", body);
    try {
      setLoading(true);
      const response = await MODULE_API.addAsset(moduleName, {
        clientModules: [body],
      });
      console.log("resposnse Upload", response);
      if (response && response.message) {
        swal("Success!", response.message, "success");
      }
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: (res && res.records) || [],
      }));
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };
  console.log("moduleData", moduleData);
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const uploadDocCols = [
    {
      title: "Link",
      dataIndex: "Document Upload",
      key: "Document Upload",
      render: (fileName, record) => {
        return record["Document Upload"] ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a style={{ color: "#7d8fb3" }} href={record["Document Upload"]} target="blank">
              {" "}
              {record["Uploaded File Name"] || extractFileNameFromUrl(record["Document Upload"])}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        window.open(record["Document Upload"]);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  return (
    <div className="">
      <div className="medical-history-title-container">
        <h2 className="medical-history-title">Medical History</h2>
        <div className="medical-history-help-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div>
      </div>
      <div className="collapse-container">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={vectorIcon}
                alt="vector-icon"
                width="20px"
                height="20px"
                style={{
                  transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </div>
          )}
        >
          <Panel header="Current Medical Conditions" key="1">
            <div className="panel-main-container">
              <div className="panel-content-container">
                {/* Header Section */}
                <div className="header-container">
                  <div className="header-title-container">
                    <h3 className="header-title">Current Medical Conditions</h3>
                  </div>
                  <div
                    className="add-condition-button-container"
                    onClick={() => showModal("Current Medical Conditions")}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={AddIcon} alt="add icon" />
                  </div>
                </div>

                {/* Table Section */}
                <div className="medical-history-table">
                  <Table
                    columns={columnsData}
                    dataSource={tableData.currentMedicalConditionsData}
                    pagination={{ pageSize: 3 }}
                  />
                  <NewLoader isLoading={loading} />
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
      <div>
        <CustomModal
          show={isModalVisible}
          fields={subModulefields && subModulefields}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? handleCreate : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>
      <div className="allergy-collapse-container">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={vectorIcon}
                alt="vector-icon"
                width="20px"
                height="20px"
                style={{
                  transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </div>
          )}
        >
          <Panel header="Medications" key="1">
            <div className="panel-main-container">
              <div className="panel-content-container">
                {/* Header Section */}
                <div className="header-container">
                  <div className="header-title-container">
                    <h3 className="header-title">Medications</h3>
                  </div>
                  <div
                    className="add-condition-button-container"
                    onClick={() => showModal("Medications")}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={AddIcon} alt="add icon" />
                  </div>
                </div>

                {/* Table Section */}
                <div className="medical-history-table">
                  <Table
                    columns={medicationColData}
                    dataSource={tableData.medicationsData}
                    pagination={{ pageSize: 3 }}
                  />
                  <NewLoader isLoading={loading} />
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>

      <div className="allergy-collapse-container">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={vectorIcon}
                alt="vector-icon"
                width="20px"
                height="20px"
                style={{
                  transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </div>
          )}
        >
          <Panel header="Allergies" key="1">
            <div className="panel-main-container">
              <div className="panel-content-container">
                {/* Header Section */}
                <div className="header-container">
                  <div className="header-title-container">
                    <h3 className="header-title">Allergies</h3>
                  </div>
                  <div
                    className="add-condition-button-container"
                    onClick={() => showModal("Allergies")}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={AddIcon} alt="add icon" />
                  </div>
                </div>

                {/* Table Section */}
                <div className="medical-history-table">
                  <Table
                    columns={allergyColData}
                    dataSource={tableData.allergiesData}
                    pagination={{ pageSize: 3 }}
                  />
                  <NewLoader isLoading={loading} />
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>

      <div className="surguries-collapse-container">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={vectorIcon}
                alt="vector-icon"
                width="20px"
                height="20px"
                style={{
                  transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </div>
          )}
        >
          <Panel header="Previous Surgeries/Procedures" key="1">
            <div className="panel-main-container">
              <div className="panel-content-container">
                {/* Header Section */}
                <div className="header-container">
                  <div className="header-title-container">
                    <h3 className="header-title">Previous Surgeries/Procedures</h3>
                  </div>
                  <div
                    className="add-condition-button-container"
                    onClick={() => showModal("Previous Surgeries/Procedures")}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={AddIcon} alt="add icon" />
                  </div>
                </div>

                {/* Table Section */}
                <div className="medical-history-table">
                  <Table
                    columns={previousSurgeriesColData}
                    dataSource={tableData.previousSurgeriesProceduresData}
                    pagination={{ pageSize: 3 }}
                  />
                  <NewLoader isLoading={loading} />
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>

      <div className="allergy-collapse-container">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={vectorIcon}
                alt="vector-icon"
                width="20px"
                height="20px"
                style={{
                  transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </div>
          )}
        >
          <Panel header="Family Medical History" key="1">
            <div className="panel-main-container">
              <div className="panel-content-container">
                {/* Header Section */}
                <div className="header-container">
                  <div className="header-title-container">
                    <h3 className="header-title">Family Medical History</h3>
                  </div>
                  <div
                    className="add-condition-button-container"
                    onClick={() => showModal("Family Medical History")}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={AddIcon} alt="add icon" />
                  </div>
                </div>

                {/* Table Section */}
                <div className="medical-history-table">
                  <Table
                    columns={familyMedicationColsData}
                    dataSource={tableData.familyMedicalHistoryData}
                    pagination={{ pageSize: 3 }}
                  />
                  <NewLoader isLoading={loading} />
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>

      <div className="allergy-collapse-container">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={vectorIcon}
                alt="vector-icon"
                width="20px"
                height="20px"
                style={{
                  transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </div>
          )}
        >
          <Panel header="Current Treatment Plans" key="1">
            <div className="panel-main-container">
              <div className="panel-content-container">
                {/* Header Section */}
                <div className="header-container">
                  <div className="header-title-container">
                    <h3 className="header-title">Current Treatment Plans</h3>
                  </div>
                  <div
                    className="add-condition-button-container"
                    onClick={() => showModal("Current Treatment Plans")}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={AddIcon} alt="add icon" />
                  </div>
                </div>

                {/* Table Section */}
                <div className="medical-history-table">
                  <Table
                    columns={currentTreamentPlan}
                    dataSource={tableData.currentTreatmentPlansData}
                    pagination={{ pageSize: 3 }}
                  />
                  <NewLoader isLoading={loading} />
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>

      <div className="allergy-collapse-container">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={vectorIcon}
                alt="vector-icon"
                width="20px"
                height="20px"
                style={{
                  transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </div>
          )}
        >
          <Panel header="Expected Future Treatments" key="1">
            <div className="panel-main-container">
              <div className="panel-content-container">
                {/* Header Section */}
                <div className="header-container">
                  <div className="header-title-container">
                    <h3 className="header-title">Expected Future Treatments</h3>
                  </div>
                  <div
                    className="add-condition-button-container"
                    onClick={() => showModal("Expected Future Treatments")}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={AddIcon} alt="add icon" />
                  </div>
                </div>

                {/* Table Section */}
                <div className="medical-history-table">
                  <Table
                    columns={estimatedTreamentPlan}
                    dataSource={tableData.expectedFutureTreatmentsData}
                    pagination={{ pageSize: 3 }}
                  />
                  <NewLoader isLoading={loading} />
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>

      {/* <div className="estimated-future-treatment-plan-container">
        <div className="estimated-future-treatment-plan-header-container">
          <div className="estimated-future-treatment-plan-header-title-container">
            <h3 className="header-title">Expected Future Treatments</h3>
          </div>
          <div
            className="add-estimated-future-treatment-plan-button-container"
            onClick={() => showModal("Expected Future Treatments")}
            style={{ cursor: "pointer" }}
          >
            <img src={AddIcon} alt="add icon" />
          </div>
        </div>
        <div className="estimated-future-treatment-plan-table-container">
          <Table
            columns={currentTreamentPlan}
            dataSource={tableData.expectedFutureTreatmentsData}
            pagination={{ pageSize: 3 }}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div> */}
      <div className="input-fields-container">
        {fields && (
          <>
            <DisabilityFormCreator
              data={fields[tabs[activeTabIndex]]}
              values={fieldsData && fieldsData}
              title={tabs[activeTabIndex]}
              setSubmitBody={setFormData}
              activeTabName={activeTabName}
            />
          </>
        )}
        {fields && (
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={() => {
                if (toUpdate) {
                  updateRecord();
                } else {
                  createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        )}
        <NewLoader isLoading={loading} />
      </div>
      <div className="upload-document-container">
        <div className="upload-document-header-container">
          <div className="upload-document-header-title-container">
            <h3 className="header-title">Upload Document</h3>
          </div>
          <div className="upload-document-button-container" style={{ cursor: "pointer" }}>
            <label
              htmlFor="UploadDocumentMedicalhistory"
              onClick={() => {
                setModuleName("Upload Document Medical history");
              }}
              style={{ cursor: "pointer", pointerEvents: loading && "none" }}
            >
              <img src={AddIcon} alt="Add File" width="24px" height="24px" />
            </label>
            <input
              type="file"
              id="UploadDocumentMedicalhistory"
              hidden
              ref={inputFileRef}
              onChange={async (event) => {
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
          </div>
        </div>

        <div className="upload-document-table-container">
          <Table columns={uploadDocCols} dataSource={tableData.uploadDocumentMedicalHistoryData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </div>
  );
}
